<template>
  <div
    class="root"
    :style="{
      width: $props.width,
      height: $props.height,
      lineHeight: $props.height,
    }"
  />
</template>

<script>
export default {
  name: 'LoadingLine',
  props: {
    width: {
      type: String,
      default: function() {
        return '100%';
      },
    },
    height: {
      type: String,
      default: function() {
        return '1rem';
      },
    },
  },
};
</script>

<style scoped lang="scss">
.root {
  border-radius: 3px;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-color: rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/elements/LoadingLine.vue